import { useNavigate, useSearch } from '@tanstack/react-router';

import {
  parseBlockedListRouteSearch,
  serializeBlockedListRouteSearch,
} from './blockedListRouteSearch';
import type { BlockedListSortDirection, BlockedListSortProperty } from './model';

export function useBlockedListRouteFilters() {
  const navigate = useNavigate({ from: '/supply/blocked-list/creatives' });
  const search = useSearch({ from: '/supply/blocked-list/creatives' });
  const filter = parseBlockedListRouteSearch(search);
  const update = (next: typeof filter) => {
    void navigate({ search: serializeBlockedListRouteSearch(next), replace: true });
  };

  return {
    filter,
    setSearch(searchTerm: string) {
      update({ ...filter, searchTerm, page: 0 });
    },
    setSort(sortProperty: BlockedListSortProperty | null, sortDirection: BlockedListSortDirection) {
      update({ ...filter, sortProperty, sortDirection, page: 0 });
    },
    setPagination(page: number, size: number) {
      update({ ...filter, page: size === filter.size ? page : 0, size });
    },
  };
}
